<template>
  <Residentials
    class="kpb-residentials"
    v-if="data.project"
    :filter="filter"
    :project="data.project"
    :properties="properties"
    v-bind="$attrs"
  />
</template>

<script>
/** Component for kvass residentials list */
import Bus from '../../bus.js'

import Residentials from '@kvass/residentials/src/Component'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      filter: {},
    }
  },
  computed: {
    properties() {
      return KvassConfig.get('siteSettings.featuredResidentialProperties') || []
    },
  },
  created() {
    Bus.on('residentials:filter', filter => (this.filter = filter))
  },
  components: {
    Residentials,
  },
}
</script>
